import { useEffect } from 'react'

import { historyEffectsActions } from '../actions'
import { useActions, useAppSelector } from '../../../store/hooks'
import { authSelector } from '../../../store/slices/auth'
import { exportSelector } from '../../../store/slices/export'
import { historyPageSelector } from '../../../store/slices/historyPage'

export function useHistoryEffects() {
    const isAuthorized = useAppSelector(authSelector.isAuthorized)
    const saveOnServer = useAppSelector(historyPageSelector.saveOnServer)
    const exportNotice = useAppSelector(exportSelector.notice)

    const {
        referenceLoadGroups,
        historyLoadExports,
        historyLoadAudit,
        historyLoadVersions,
    } = useActions(historyEffectsActions)

    useEffect(() => {
        if (!isAuthorized) return

        referenceLoadGroups()
        historyLoadVersions()
        historyLoadExports()
        historyLoadAudit()
    }, [
        isAuthorized,
        referenceLoadGroups,
        historyLoadVersions,
        historyLoadExports,
        historyLoadAudit,
    ])

    useEffect(() => {
        if (exportNotice && saveOnServer) {
            historyLoadExports()
        }
    }, [exportNotice, saveOnServer, historyLoadExports])
}
